import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
  Home, AlertTriangle, CheckCircle2, XCircle, 
  ChevronDown, ChevronUp, Lightbulb
} from 'lucide-react';

const mistakesData = [
  {
    id: 1,
    category: 'Görünüm',
    emoji: '👔',
    color: 'from-purple-500 to-pink-600',
    mistakes: [
      {
        wrong: 'Gündelik kıyafet giymek',
        right: 'Profesyonel takım elbise/kıyafet',
        explanation: 'İlk izlenim çok önemli. Kabin memuru gibi görünmelisiniz.'
      },
      {
        wrong: 'Aşırı makyaj veya parfüm',
        right: 'Doğal makyaj, hafif koku',
        explanation: 'Uçakta yolcular rahatsız olabilir. Doğallık tercih edilir.'
      },
      {
        wrong: 'Bakımsız tırnaklar veya saç',
        right: 'Düzenli, temiz görünüm',
        explanation: 'Grooming standartları havayolları için kritik.'
      },
      {
        wrong: 'Görünür dövme veya piercing',
        right: 'Kapatılmış dövme, minimal takı',
        explanation: 'Birçok havayolu görünür dövmeleri kabul etmez.'
      },
      {
        wrong: 'Kirli veya eski ayakkabı',
        right: 'Temiz, cilalı klasik ayakkabı',
        explanation: 'Ayakkabılar dikkatle incelenir.'
      }
    ]
  },
  {
    id: 2,
    category: 'Davranış',
    emoji: '🎭',
    color: 'from-blue-500 to-indigo-600',
    mistakes: [
      {
        wrong: 'Göz teması kurmamak',
        right: 'Doğal göz teması, gülümseme',
        explanation: 'Göz teması güven ve samimiyet gösterir.'
      },
      {
        wrong: 'Kolları kavuşturmak',
        right: 'Açık, rahat beden dili',
        explanation: 'Kavuşmuş kollar savunmacı görünür.'
      },
      {
        wrong: 'Bacak sallamak veya tırnak yemek',
        right: 'Sakin ve kontrollü duruş',
        explanation: 'Gerginlik belirtileri negatif izlenim yaratır.'
      },
      {
        wrong: 'Jüriyle yarışmak veya tartışmak',
        right: 'Saygılı, dinleyici olmak',
        explanation: 'Ego gösterisi eleme nedenidir.'
      },
      {
        wrong: 'Diğer adaylara kötü davranmak',
        right: 'Herkese nazik ve yardımsever olmak',
        explanation: 'Grup mülakatlarında takım oyuncusu aranır.'
      }
    ]
  },
  {
    id: 3,
    category: 'Cevaplar',
    emoji: '💬',
    color: 'from-emerald-500 to-teal-600',
    mistakes: [
      {
        wrong: 'Ezber cevap vermek',
        right: 'Doğal ve kişisel cevaplar',
        explanation: 'Robotik cevaplar samimiyetsiz görünür.'
      },
      {
        wrong: '"Seyahat etmek istiyorum" demek',
        right: 'İnsanlara hizmet tutkusu vurgulamak',
        explanation: 'Seyahat ikincil bir fayda, asıl odak hizmettir.'
      },
      {
        wrong: 'Eski işveren hakkında kötü konuşmak',
        right: 'Pozitif ve yapıcı olmak',
        explanation: 'Şikayetçi adaylar risk olarak görülür.'
      },
      {
        wrong: 'Çok kısa veya çok uzun cevaplar',
        right: '30-90 saniye arası, yapılandırılmış',
        explanation: 'STAR tekniği kullanın, özet ve net olun.'
      },
      {
        wrong: '"Bilmiyorum" demek',
        right: 'Dürüst ama yapıcı yaklaşım',
        explanation: '"Henüz deneyimim yok ama şöyle yaklaşırdım..."'
      }
    ]
  },
  {
    id: 4,
    category: 'Hazırlık',
    emoji: '📋',
    color: 'from-orange-500 to-red-600',
    mistakes: [
      {
        wrong: 'Havayolu hakkında araştırma yapmamak',
        right: 'Şirket bilgisi, destinasyonlar, değerler',
        explanation: '"Neden bu havayolu?" sorusuna hazır olun.'
      },
      {
        wrong: 'Güncel havacılık haberlerini takip etmemek',
        right: 'Son 1 haftanın haberlerini okumak',
        explanation: 'Sektöre ilginizi gösterir.'
      },
      {
        wrong: 'CV\'deki bilgileri unutmak',
        right: 'CV\'nizi ezbere bilin',
        explanation: 'Kendi deneyimleriniz hakkında sorulacak.'
      },
      {
        wrong: 'Mülakat yerine geç kalmak',
        right: 'En az 30 dakika erken varmak',
        explanation: 'Gecikme toleransı yoktur.'
      },
      {
        wrong: 'Belgeleri eksik getirmek',
        right: 'Tüm istenenleri dosyada hazırlamak',
        explanation: 'Organizasyon becerisi değerlendirilir.'
      }
    ]
  },
  {
    id: 5,
    category: 'İletişim',
    emoji: '🗣️',
    color: 'from-cyan-500 to-blue-600',
    mistakes: [
      {
        wrong: 'Çok hızlı veya yavaş konuşmak',
        right: 'Anlaşılır tempo, net artikülasyon',
        explanation: 'Anons yapacaksınız, anlaşılmanız kritik.'
      },
      {
        wrong: '"Eee", "şey" gibi dolgu sesleri',
        right: 'Kısa duraksama, sonra devam',
        explanation: 'Düşünmek için sus, düşündükten sonra konuş.'
      },
      {
        wrong: 'İngilizce\'de Türkçe kalıplar kullanmak',
        right: 'Doğru gramer ve akıcılık',
        explanation: 'İngilizce mülakatı ciddi hazırlık gerektirir.'
      },
      {
        wrong: 'Jüriyi kesmek',
        right: 'Soru bitene kadar beklemek',
        explanation: 'Dinleme becerisi değerlendirilir.'
      },
      {
        wrong: 'Tek kelimelik cevaplar',
        right: 'Açıklayıcı, örnekli cevaplar',
        explanation: 'İletişim becerilerinizi gösterin.'
      }
    ]
  },
  {
    id: 6,
    category: 'Grup Mülakatı',
    emoji: '👥',
    color: 'from-pink-500 to-rose-600',
    mistakes: [
      {
        wrong: 'Gruba hakim olmaya çalışmak',
        right: 'Dengeli katılım, başkalarına söz hakkı',
        explanation: 'Liderlik ≠ Baskınlık'
      },
      {
        wrong: 'Hiç konuşmamak',
        right: 'Aktif katılım, fikirlerini paylaşmak',
        explanation: 'Görünmezlik eleme nedenidir.'
      },
      {
        wrong: 'Diğerlerinin fikirlerini eleştirmek',
        right: 'Yapıcı katkı, fikir geliştirme',
        explanation: '"Evet ve..." yaklaşımı kullanın.'
      },
      {
        wrong: 'Sadece jüriye odaklanmak',
        right: 'Tüm gruba hitap etmek',
        explanation: 'Takım çalışması değerlendirilir.'
      },
      {
        wrong: 'Stresli görünmek',
        right: 'Rahat ve kendinden emin duruş',
        explanation: 'Acil durumlarda sakin kalmalısınız.'
      }
    ]
  }
];

export default function InterviewMistakes({ onBack }) {
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [viewedMistakes, setViewedMistakes] = useState([]);

  const toggleCategory = (categoryId) => {
    if (expandedCategory === categoryId) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(categoryId);
      if (!viewedMistakes.includes(categoryId)) {
        setViewedMistakes([...viewedMistakes, categoryId]);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <div className="bg-gradient-to-br from-red-600 to-rose-600 px-4 pt-6 pb-8 rounded-b-[2rem]">
        <div className="max-w-4xl mx-auto">
          <button 
            onClick={onBack}
            className="flex items-center gap-2 text-white/80 hover:text-white mb-4"
          >
            <Home className="w-5 h-5" />
            <span className="font-medium">Pratik Merkezi</span>
          </button>
          
          <div className="text-center text-white">
            <AlertTriangle className="w-12 h-12 mx-auto mb-2 text-yellow-300" />
            <h1 className="text-2xl font-bold">Yapılan Hatalar</h1>
            <p className="text-red-100 text-sm mt-1">Kaçınılması gereken yaygın hatalar</p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 mt-6">
        {/* Progress */}
        <Card className="mb-6 bg-gradient-to-r from-yellow-50 to-orange-50 border-yellow-200">
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Lightbulb className="w-8 h-8 text-yellow-500" />
                <div>
                  <p className="font-semibold text-gray-800">İncelenen Kategoriler</p>
                  <p className="text-sm text-gray-600">{viewedMistakes.length} / {mistakesData.length}</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-yellow-600">
                {Math.round((viewedMistakes.length / mistakesData.length) * 100)}%
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Categories */}
        <div className="space-y-4">
          {mistakesData.map((category) => (
            <Card 
              key={category.id}
              className={`overflow-hidden transition-all ${
                viewedMistakes.includes(category.id) ? 'ring-2 ring-green-500' : ''
              }`}
            >
              <CardContent className="p-0">
                <button
                  onClick={() => toggleCategory(category.id)}
                  className="w-full p-4 flex items-center justify-between"
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${category.color} flex items-center justify-center`}>
                      <span className="text-2xl">{category.emoji}</span>
                    </div>
                    <div className="text-left">
                      <h3 className="font-bold text-gray-800">{category.category}</h3>
                      <p className="text-sm text-gray-500">{category.mistakes.length} hata</p>
                    </div>
                  </div>
                  {expandedCategory === category.id ? (
                    <ChevronUp className="w-5 h-5 text-gray-400" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-400" />
                  )}
                </button>

                {expandedCategory === category.id && (
                  <div className="px-4 pb-4 space-y-3">
                    {category.mistakes.map((mistake, index) => (
                      <div key={index} className="bg-gray-50 rounded-xl p-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                          <div className="flex items-start gap-2">
                            <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                            <div>
                              <p className="text-sm font-medium text-red-700">Yanlış</p>
                              <p className="text-sm text-gray-700">{mistake.wrong}</p>
                            </div>
                          </div>
                          <div className="flex items-start gap-2">
                            <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                            <div>
                              <p className="text-sm font-medium text-green-700">Doğru</p>
                              <p className="text-sm text-gray-700">{mistake.right}</p>
                            </div>
                          </div>
                        </div>
                        <div className="bg-blue-50 rounded-lg p-3">
                          <p className="text-sm text-blue-800">
                            <span className="font-medium">💡 Neden?</span> {mistake.explanation}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Summary Card */}
        <Card className="mt-6 bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200">
          <CardContent className="p-4">
            <h3 className="font-semibold text-gray-800 mb-2">🎯 Altın Kural</h3>
            <p className="text-sm text-gray-600">
              Mülakatta en önemli 3 şey: <strong>Profesyonel görünüm</strong>, 
              <strong> samimi iletişim</strong> ve <strong>hazırlıklı olmak</strong>. 
              Bu hataları bilmek kadar, pratik yapmak da önemli!
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
